import 'whatwg-fetch';
import 'babel-polyfill';
import { OptimizedResizeInstance } from 'js/components/Util/OptimizedResize.js';
import { SpinnerModal } from 'js/components/SpinnerModal/SpinnerModal.js';
import { LocationHours } from 'js/components/LocationHours/index.js';
import { Maps } from 'js/components/Maps/index.js';

const Raven = require('raven-js/dist/raven.js');
Raven.config('https://13d7b1cf5db9462a8a6121dfd4d032c5@sentry.io/751790').install();
const URI = require('urijs');

import { Form } from 'js/components/Cobalt/Locator/Form.js';
import { FilterModal } from 'js/components/Cobalt/Locator/FilterModal.js';

import { HTML5Geolocation } from 'js/components/Util/Html5Geolocation.js';
HTML5Geolocation.initClass();

import { ReverseGeolocation } from 'js/components/Util/ReverseGeolocation.js';
ReverseGeolocation.initClass();

let queryIsEmpty = function(query) {
  return query == "?" || query == "";
}

export class Locator {
  constructor(el, form, renderer, stateChangeCallback, config) {
    this.el = el;
    this.inputEl = this.el.querySelector('.js-locator-input');
    this.resultsContainer = this.el.querySelector('.js-locator-resultsContainer');
    this.form = form;
    this.renderer = renderer;
    this.stateChangeCallback = stateChangeCallback || (() => {});
    this.config = config;

    this.spinner = new SpinnerModal();

    this.form.bindSubmitHandler(this.submitHandler.bind(this));
    window.onpopstate = this.popHandler.bind(this);

    const geolocateButton = this.form.el.querySelector('.js-locator-geolocateTrigger');
    if (geolocateButton) {
      geolocateButton.addEventListener('click', () => {this.geolocate(this.inputEl)});
    }

    this.onLoad();
    if (this.config.locationOnLoad && window.location.href.indexOf('?q') === -1) {
      navigator.permissions.query({name: 'geolocation'}).then(result => {
        if (result.state == 'granted') {
          this.geolocate(this.inputEl);
        }
        else {
          this.ipLocate(this.inputEl)
        }
      })
    }
  }

  popHandler(evt) {
    this.renderer.render(evt.state);
    this.form.deserialize(window.location.search);
    this.stateChangeCallback();
  }

  async setQueryParams(position, input, isHTML5) {
    const currentUrl = `${window.location.pathname}`;
    const queryString = `q=${position.latitude},${position.longitude}`;
    let results = null;
    let formValues = this.form.serialize();
    let params = new URI(`?${formValues}`);
    params.removeSearch('q');
    try {
      results = await this.search(queryString);
      const queryLocation = results.queryLocation;
      if (queryLocation) {
        input.value = `${queryLocation.city}, ${queryLocation.state} ${queryLocation.zip}`;
      } else {
        input.value = `${position.latitude},${position.longitude}`;
      }
      params.addSearch({ q : `${position.latitude},${position.longitude}` });
      window.history.pushState(results, "", `${currentUrl}${params.toString()}`);
      this.renderer.render(results);
      if (isHTML5) {
        this.spinner.hideSpinner();
      }
    } catch(err) {
      if (isHTML5) {
        console.log("HTML5 Geolocation Error: ", err);
        Raven.captureException(err, {
          extra: {
            details: 'HTML5 Geolocation: Error searching after geolocation',
            queryString: queryString
          }
        });
      }
      else {
        console.log("IP Geolocation Error: ", err);
          Raven.captureException(err, {
            extra: {
              details: 'IP Geolocation Error: Error searching after geolocation',
              queryString: queryString
            }
        });
      }
    }
  }

  async geolocate(input) {
    this.spinner.showSpinner();
    HTML5Geolocation.getCurrentLocation(async (position) => {
      if (position.hasOwnProperty('latitude') && position.hasOwnProperty('longitude')) {
        this.setQueryParams(position, input, true);
      } else {
        console.log("HTML5 Geolocation: Error no position found.");
      }
    }, () => {
      this.spinner.hideSpinner();
      if (this.config.locationOnLoad) {
        this.ipLocate(input);
      }
      console.log("HTML5 Geolocation: Error no position found.");
    });
  }

  async ipLocate(input) {
    ReverseGeolocation.getCurrentLocation(async (position) => {
      if (position.hasOwnProperty('latitude') && position.hasOwnProperty('longitude')) {
        this.setQueryParams(position, input);
      }
    }, () => {
      console.log("IP Geolocation Error: unable to locate user.");
    });
  }

  async onLoad() {
    const currentUrl = `${window.location.pathname}`;
    const currentQuery = window.location.search;
    const locatorParamsEl = this.el.querySelector('.js-locator-params');
    this.templateParams = locatorParamsEl ? JSON.parse(locatorParamsEl.innerHTML) : {};
    Raven.setExtraContext({
      site: this.templateParams.siteInternalHostName ? this.templateParams.siteInternalHostName : 'unknown'
    });
    if (queryIsEmpty(currentQuery)) {
      const data = JSON.parse(this.el.querySelector('.js-locator-initialData').innerHTML);
      window.history.replaceState(data,"", `${currentUrl}`);
      return;
    }

    this.form.deserialize(currentQuery);
    window.history.replaceState({},"", `${currentUrl}${currentQuery}`);
    let data = null;
    try {
      data = await this.submitAndRender();
      window.history.replaceState(data, "", `${currentUrl}${currentQuery}`);
    } catch(err) {
      console.log("err: ", err);
      Raven.captureException(err, {
        extra: {
          details: 'Initial search after deserializing from url',
          queryString: currentQuery
        }
      });
    }
    this.stateChangeCallback();
  }

  async submitHandler(evt) {
    if (evt) evt.preventDefault();

    // Hack to hide the mobile keyboard
    this.inputEl.setAttribute('readonly', true);
    window.setTimeout(() => {
      this.inputEl.blur();
      this.inputEl.removeAttribute('readonly');
    }, 100);

    const currentUrl = `${window.location.pathname}`;
    const query = this.form.serialize();
    let initialFormQueryMap = new URI(window.location.href).search(true);
    let formQueryMap = new URI(`?${query}`).search(true);
    let formParameters = this.form.getFieldsByName();
    Object.keys(initialFormQueryMap).forEach(function(key) {
      if (!(key in formQueryMap) && (key in formParameters)) {
        formQueryMap[key] = [];
      }
    });
    let currentURI = new URI(window.location.href).setSearch(formQueryMap);
    window.history.pushState({}, "", currentURI.toString());
    let data = null;
    try {
      data = await this.submitAndRender();
      window.history.replaceState(data, "", currentURI.toString());
    } catch(err) {
      console.log("err: ", err);
      Raven.captureException(err, {
        extra: {
          details: 'Standard search',
          queryString: query
        }
      });
    }
  }

  async submitAndRender() {
    const query = this.form.serialize();
    return this.searchAndRender(query);
  }

  async searchAndCallback(query, cb) {
    Yext.Analytics.send({eventType: 'search'});
    this.spinner.showSpinner();
    const startTime = performance.now();
    const results = await this.search(query);
    if (cb) {
      cb(results)
    }
    const finishTime = performance.now();
    if ((finishTime - startTime) > 500) {
      this.spinner.hideSpinner();
    } else {
      window.setTimeout(this.spinner.hideSpinner.bind(this.spinner), 500 - (finishTime - startTime));
    }
    return results
  }

  async searchAndRender(query) {
    return this.searchAndCallback(query, this.renderer.render.bind(this.renderer));
  }

  async search(query) {
    const fetchInit = {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
      }
    };
    try {
      const response = await fetch(`${this.form.getAction()}?${query}`, fetchInit);
      return response.json();
    } catch(err) {
      Raven.captureException(err, {
        extra: {queryString: query,}
      });
      return Promise.reject(e)
    }
  }
}
